/* global ace */
ace.define("ace/snippets/yaml",
  ["require","exports","module"], function(e,t,n){ // eslint-disable-line no-unused-vars
    t.snippetText=undefined
    t.scope="yaml"
  })



// WEBPACK FOOTER //
// src/plugins/editor/components/brace-snippets-yaml.js